module.exports = __webpack_public_path__ + "c7654e7ca0520d810e72e88eda7e60ce.pdf";